<template>
  <div v-if="options.length" class="form__input">
    <div class="main-display" @click="openPopOut">
      <span>
        <font-awesome-icon :icon="['fas', 'user-tag']" class="icon alt" />
        <label class="mb-0">Selected User Tags</label>
        <b style="margin-left:3px;">({{ value && value.length || 0 }})</b>
      </span>
      <font-awesome-icon
        :icon="['fas', 'chevron-down']"
        class="icon alt down-arrow"
        aria-hidden="true"
      />
    </div>
    <div v-if="open" v-clickoutside="closePopOut" class="pop-out">
      <div v-for="option in options" :key="option.value" class="selection" @click="emit(option)">
        <div class="checkbox" :class="value && value.indexOf(option.value) > -1 ? 'selected' : ''">
        </div>
        <label :class="value && value.indexOf(option.value) > -1 ? 'selected' : ''">{{ option.display }}</label>
      </div>
    </div>
  </div>
</template>
<script>

export default {
    name: 'CustomTagsInput',
    inject:['customUserTags'],
    directives: {
        clickoutside: {
            bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent);
            document.body.addEventListener('touchstart', el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
                document.body.removeEventListener('touchstart', el.clickOutsideEvent);
            },
            stopProp(event) {
                event.stopPropagation();
            }
        }
    },
    props: {
        value: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            open: false,
            input: '',
        }
    },
    computed: {
        options() {
            return (this.customUserTags.customTags.tags || []).map((x) => ({ value: x, display: x }));
        },
        selectedCount() {
            let count = 0;
            this.options.forEach(option => {
                if (this.isSelected(option)) {
                    count++;
                }
            });
            return count;
        },
    },
    methods: {
        openPopOut() {
            if (!this.open) {
                setTimeout(() => this.open = true)
            }
        },
        closePopOut() {
            this.open = false;
        },
        isSelected(option) {
            return this.value && this.value.contains(option.value)
        },
        emit(option) {
            const value = [...this.value]
            const index = value.indexOf(option.value);
            if (index === -1) { // add
                value.push(option.value)
            } else { // remove
                value.splice(index, 1)
            }
            this.$emit('input', value);
        }
    }
}
</script>

<style lang="scss">
.selection {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  label {
    margin-left: 5px;
    cursor: pointer;
    &.selected {
        font-weight: bold;
    }
  }
  .checkbox {
    cursor: pointer;
    display: inline-block;
    border-radius: 5px;
    width: 5px;
    height: 25px;
  }
  .checkbox.selected {
    background-color: $approval-green;
  }
}
.down-arrow {
  margin-left: 7px;
}
.main-display {
  width: 250px;
  color-scheme: light;
  background: #fff;
  border: 1px solid #d1d1d1;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: 8px;
  padding: 10px;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;
  cursor: pointer;

  .icon {
    font-size: 18px;
    margin-right: 8px;
  }
}
.pop-out {
  width: 250px;
  color-scheme: light;
  background: #fff;
  border: 1px solid #d1d1d1;
  border-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  position: absolute;
  flex-wrap: nowrap;
  padding: 10px;
  margin-top: -5px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 9999;
}
</style>
